export const KIOSK_LOCK_KEY = "assemble_kiosk_lock_v2";
const LEGACY_KIOSK_LOCK_KEY = "assemble_kiosk_lock_v1";

export interface KioskLock { anchorSessionId: string }
export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function browserStorage(): StorageLike | null {
  try { return typeof window === "undefined" ? null : window.localStorage; }
  catch { return null; }
}
function validSessionId(value: string): boolean {
  return value.length > 0 && value.length <= 200 && !/[\u0000-\u001f]/.test(value);
}
export function kioskPath(anchorSessionId: string): string {
  return `/admin/kiosk/${encodeURIComponent(anchorSessionId)}`;
}
export function readKioskLock(storage: StorageLike | null = browserStorage()): KioskLock | null {
  if (!storage) return null;
  try {
    const current = storage.getItem(KIOSK_LOCK_KEY) || "";
    const raw = current || storage.getItem(LEGACY_KIOSK_LOCK_KEY) || "";
    if (!raw) return null;
    let anchorSessionId = "";
    if (!raw.startsWith("{")) anchorSessionId = raw;
    else {
      const value = JSON.parse(raw) as { anchorSessionId?: string; sessionId?: string };
      anchorSessionId = value.anchorSessionId || value.sessionId || "";
    }
    if (!validSessionId(anchorSessionId)) return null;
    if (!current) {
      storage.setItem(KIOSK_LOCK_KEY, JSON.stringify({ anchorSessionId } satisfies KioskLock));
      storage.removeItem(LEGACY_KIOSK_LOCK_KEY);
    }
    return { anchorSessionId };
  } catch { return null; }
}
export function lockKiosk(anchorSessionId: string, storage: StorageLike | null = browserStorage()): void {
  if (!storage || !validSessionId(anchorSessionId)) return;
  storage.setItem(KIOSK_LOCK_KEY, JSON.stringify({ anchorSessionId } satisfies KioskLock));
}
export function clearKioskLock(storage: StorageLike | null = browserStorage()): void {
  try {
    storage?.removeItem(KIOSK_LOCK_KEY);
    storage?.removeItem(LEGACY_KIOSK_LOCK_KEY);
  } catch { /* Storage can be disabled by the browser. */ }
}
export function enforcedKioskPath(currentPath: string, storage: StorageLike | null = browserStorage()): string | null {
  const lock = readKioskLock(storage);
  if (!lock) return null;
  const requiredPath = kioskPath(lock.anchorSessionId);
  return currentPath === requiredPath ? currentPath : requiredPath;
}
export async function openClassroomDisplay(anchorSessionId: string): Promise<void> {
  const fullscreen = document.documentElement.requestFullscreen?.().catch(() => undefined);
  lockKiosk(anchorSessionId);
  const path = kioskPath(anchorSessionId);
  history.pushState({ kiosk: true, anchorSessionId }, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  await fullscreen;
}